import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(6),
    marginBottom: theme.spacing(6)
  },
  coverageChange: {
    border: `2px solid ${theme.colorPalette.beige_50}`,
    borderRadius: '6px',
    padding: theme.spacing(5, 3, 5, 3),
    margin: theme.spacing(2, 0, 2, 0),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  fieldAndChange: {
    flexGrow: 2,
    marginLeft: theme.spacing(4)
  },
  changeInfo: {
    marginTop: theme.spacing(3),
    textWrap: 'pretty'
  },
  rightArrow: {
    margin: theme.spacing(0, 2, 0, 2),
    width: '8px'
  },
  fieldName: {
    marginBottom: theme.spacing(2)
  },
  removedValue: {
    textDecoration: 'line-through',
    paddingLeft: theme.spacing(2),
    lineHeight: '1.5'
  },
  addedValue: {
    lineHeight: '1.5'
  },
  change: {
    lineHeight: '1.5'
  },
  loading: {
    color: theme.colors.loading_bar,
    marginRight: theme.spacing(2)
  }
}));

export default useStyles;
